module.exports = "/_next/static/images/vu-e96192d92e219615474ba07b5678666f.svg";